import * as React from "react";
import { useState, useEffect } from "react";
//import {atom, useSetRecoilState, useRecoilValue} from "recoil";
import $ from 'jquery';
import {useFirebaseUser} from "./firebase-auth";

export function ValidateWinner({accessToken}) {
  //console.log("TOKEN: " + accessToken);
  const firebaseUser = useFirebaseUser()
  const [didValidate, setDidValidate] = useState(false);
  const [validateInfo, setValidateInfo] = useState(null);

  useEffect(() => {
  	// Confirm the link is a sign-in with email link.
  	if (firebaseUser.didAuth && !didValidate) {

	  setDidValidate(true);

	  $.ajax('https://0eg36enfd5.execute-api.us-west-2.amazonaws.com/dev/validateWinner', {
		method: 'GET',
		beforeSend: function (xhr) {
		    xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
		},
		data: {
			externalAccountId: 'totallyrealfirebaseid'
		}
	  }).done(function(oData) {
		if (oData) {
			//console.log(oData);
		}
	  }).fail(function(jqXHR, textStatus) {
		console.log( "ValidateWinner failed: " + textStatus );
	  });
	  
	}   
  });

  return (
  	<div>
  	{	
  		didValidate && 
  		<div>
  		{validateInfo}
  		</div>
  	}
  	</div>
  );
};